<template>
  <el-dialog
    :visible="!!changeCycle"
    title="修改设置"
    width="1000px"
    @close="closeDialog"
  >
    <el-form :model="detail" ref="form" :rules="rules" label-width="150px">
      <el-form-item label="借贷币种：" prop="borrowCoinType">
        <span>{{ detail.borrowCoinType }}</span>
      </el-form-item>
      <el-form-item label="周期：" prop="numberDays">
        <span>{{ detail.numberDays }}</span>
      </el-form-item>
      <el-form-item label="年化利率：" prop="yearRate">
        <el-input-number
          v-model="detail.yearRate"
          :min="0"
          :max="1"
          :step="0.1"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="违约利率：" prop="defaultRate">
        <el-input-number
          v-model="detail.defaultRate"
          :min="0"
          :max="1"
          :step="0.1"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="逾期利率" prop="overdueRate">
        <el-input-number
          v-model="detail.overdueRate"
          :min="0"
          :max="1"
          :step="0.1"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: 'cycleDetail',
  data() {
    return {
      detail: {},
      rules: {
        borrowingMortgageScale: {
          required: true,
          message: '请填写'
        },
        numberDays: {
          required: true,
          message: '请填写'
        },
        yearRate: {
          required: true,
          message: '请填写'
        },
        defaultRate: {
          required: true,
          message: '请填写'
        },
        overdueRate: {
          required: true,
          message: '请填写'
        }
      }
    };
  },
  computed: {
    ...mapState('mortgage', ['changeCycle'])
  },
  watch: {
    changeCycle(val) {
      this.detail = {
        ...val
      };
    }
  },
  components: {},
  methods: {
    ...mapMutations('mortgage', ['setchangeCycle']),
    ...mapActions('mortgage', ['update']),
    closeDialog() {
      this.setchangeCycle(null);
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.doSave();
        }
      });
    },
    doSave() {
      const submitData = {
        id: this.detail.id,
        borrowCoinType: this.detail.borrowCoinType,
        numberDays: this.detail.numberDays,
        yearRate: this.detail.yearRate,
        defaultRate: this.detail.defaultRate,
        overdueRate: this.detail.overdueRate
      };
      this.update(submitData).then(() => {
        this.$message({
          message: '修改成功！',
          type: 'success'
        });
        this.closeDialog();
        this.$emit('refresh');
      });
    }
  }
};
</script>
